import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mprd-flex-emergency-entry-pxsplus',
  templateUrl: './flex-emergency-entry-pxsplus.component.html',
})
export class FlexEmergencyEntryPxsplusComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goToStep2() {
    this.router.navigate(['/pxsplus/flex-emergency-manage']);
  }
}
